import { transformSelectedReport } from 'app/area/favourite/favourite-definition-transforms/selected-report';
import { FavouriteDefinition, Value } from 'app/types-shared';

export const updateLayoutType = (def: FavouriteDefinition, layoutType: Value) => 
  transformSelectedReport({
    layoutType
  })(def);
